import React from 'react'
import {Link} from 'react-router-dom'
import { useTranslation } from "react-i18next";

const breadcrumbs = ({crumbs}) => {

    const { t, i18n } = useTranslation();

    return (

        <div className="container container--larger">

            <ul className="breadcrumb">
                {/* Link back to any previous steps of the breadcrumb. */}
                { (crumbs.length <= 1) ?
                    (<li className="breadcrumb-item"><strong>{t("breadcrumbs.homepage")}</strong></li>)
                    : (
                        crumbs.map(({name, path}, key) =>

                                key + 1 === crumbs.length ? (
                                    <li className="breadcrumb-item last-item" key={key} ><span  className="last">{t(name)}</span></li>
                                ) : (
                                    <li className="breadcrumb-item" key={key} ><Link className=""
                                                                          to={path}>
                                        <strong>{t(name)}</strong>
                                    </Link></li>
                                )
                            )
                    )
                }


            </ul>
        </div>


    );
};


export default breadcrumbs
